import { put, call, takeLatest, all } from 'redux-saga/effects'
import AuditLogTypes from './types';
import request from 'utils/request';
import { DEFAULT_ERROR_MESSAGE } from 'utils/constants';
import urls from 'utils/config';
import { fetchAuditLogSuccess,fetchAuditLogFailure, } from './actions';
import { networkErrorHandler } from 'utils/errrorHandlers';

const { API_BASE_URL } = urls || {};

function* fetchAuditLog( {data} ) {
    const { size = 10, timeframe = [], search, status, page = 0} = data;
    const url = `${API_BASE_URL}/audit/event-log?limit=${size}&offset=${page}${
        search ? `&username=${encodeURIComponent(search)}` : ''
        }${status ? `&eventStatus=${status}` : ''
        }${timeframe.length ? `&from=${timeframe[0].toISOString()}` : '' 
        }${timeframe.length ? `&to=${timeframe[1].toISOString()}` : ''
        }`

    const response = yield request({
        method: 'get',
        url,
    });

    if (response.success) {
        yield put(fetchAuditLogSuccess(response.raw))
    } else {
        yield put(fetchAuditLogFailure(DEFAULT_ERROR_MESSAGE))
        networkErrorHandler(response?.statusCode, response?.message);
    }
} 

function* onFetchAuditLog() {
    yield takeLatest(
        AuditLogTypes.FETCH_AUDIT_LOG_START,
        fetchAuditLog
    )
}

export function* auditLogSagas() {
    yield all([call(onFetchAuditLog)])
}
